import Dinero from 'dinero.js'

export const inputToInteger = (value) => {
  if (value) {
    const strValue = value.toString();

    const [whole, decimal] = strValue.split('.');

    const safeDecimal = (decimal || '').substring(0, 2).padEnd(2, '0');

    const result = parseInt(`${whole}${safeDecimal}`, 10);

    return Number.isNaN(result) ? 0 : result;
  } else {
    return 0;
  }
}

export const intToCurrency = (amount) => {
  return Dinero({ amount }).toFormat('0,0.00');
}

export const sum = (result, item) => {
  return result + Number(item || 0.0);
}

